$(document).ready(function() {
  $(".expandable-content__toggle").click(function(){
    document.querySelector(".collection__description").classList.toggle('expandable-content');
    const i = document.querySelector(".expandable-content__toggle-text");
    const more = i.getAttribute('data-view-more');
    const less = i.getAttribute('data-view-less');

    let containsexpandablec = document.querySelector(".collection__description").classList.contains('expandable-content');
    console.log(containsexpandablec);
    if (containsexpandablec) {
      i.innerHTML = more;
    }
    else i.innerHTML = less;
  });
});

(function () {
  const calcMinHeight = () => {
    const facetsTop = document.querySelector('.facets__top');
    const sortWrapper = document.querySelector('.facets__sort-wrapper');
    const collectionWrapper = document.querySelector('.collection-wrapper');

    if (facetsTop && sortWrapper && collectionWrapper) {
      collectionWrapper.style.gridTemplateRows =  sortWrapper.getBoundingClientRect().height+'px auto 1fr';
    }
  }

  const resizeCollectionGrid = () => {
		const collectionGridSection = document.querySelector('.collection-grid-section') || document.querySelector('.section-search');

		const sectionResizeObserver = new ResizeObserver((entries) => {

			const [entry] = entries;
      calcMinHeight();
		});

		sectionResizeObserver.observe(collectionGridSection);
	}

  document.addEventListener('shopify:section:load', function () {
		resizeCollectionGrid();
	});

	resizeCollectionGrid();

    
})();